import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export const HalloweenFrame: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const { t } = useTranslation();

    return (
        <Box display="flex" flexDirection="column" width="100%">
            <Box display="flex" justifyContent="center">
                ꧁༺༒☬ <span>🌺</span> <span>💀</span> <span>🌹</span> ☬༒༻꧂
            </Box>

            <Box mb={2} mt={2}>
                {children}
            </Box>

            <Box display="flex" justifyContent="center">
                <Typography variant="h4" color="textPrimary">
                    <span>🍫</span> {t('Messages.Halloween')} <span>🍫</span>
                </Typography>
            </Box>
        </Box>
    );
};
